<template>
    <q-card style="width: 500px;">
        <q-card-section>
            <slot name="title"></slot>
        </q-card-section>
        <q-separator />
        <q-card-section>
            <slot name="message"></slot>
        </q-card-section>
        <q-card-actions align="right" class="bg-white">
            <q-btn label="OK" v-close-popup color="primary"/>
        </q-card-actions>
    </q-card>
</template>
<script>

export default {
    name: "AlertUserDialog",
}
</script>
